class wrSearch extends HTMLElement {
  constructor() {
    super();
    this.limit = this.dataset.limit;
    this.trendingProductsCount = this.dataset.trendingProducts == 'true';
    this.instantSearchContent = this.querySelector('.wr-instant-search__trending-products');
    this.searchInput = document.querySelector('.header-search__input');
    this.instantSearch = this.querySelector('.wr-instant-search');
    this.predictiveSearch = this.querySelector('.wr-predictive-search');
    this.collectionResults = this.querySelector('.wr-predictive-search__collection-results');
    this.pageResults = this.querySelector('.wr-predictive-search__page-results');
    this.productResults = this.querySelector('.wr-predictive-search__products');
    this.noResults = this.querySelector('.wr-predictive-search__no-results');
    this.submitButton = this.querySelector('.wr-predictive-search__form-submit');
    this.popularCollections = this.querySelector('.wr-predictive-popular__collections');
    this.hiddenClass = 'tw-hidden';
  }

  connectedCallback() {
    if (!this.trendingProductsCount) this.getTrendingProducts();
    this.debouncedSearch = this.debounce(this.onChangeSearchInput.bind(this), 1000);
    this.searchInput.addEventListener('input', this.debouncedSearch);
    this.searchInput.addEventListener('keydown', this.onKeydownSearchInput.bind(this));
  }

  async getTrendingProducts() {
    try {
      const response = await fetch('/collections/all/?sort_by=best-selling', {
        credentials: 'same-origin',
        method: 'GET',
      });
      const responseText = await response.text();
      const productCards = new DOMParser().parseFromString(responseText, 'text/html').querySelectorAll('wr-product-card');
      Array.from(productCards).slice(0, this.limit).forEach(productCard => {
        this.instantSearchContent.appendChild(productCard);
      });
    } catch (error) {
      console.error('Error fetching trending products:', error);
    }
  }

  onKeydownSearchInput(e) {
    if (e.code === 'Enter') e.preventDefault();
  }

  onChangeSearchInput(e) {
    const searchQuery = this.searchInput.value;
    this.instantSearch.classList.toggle(this.hiddenClass, searchQuery);
    this.predictiveSearch.classList.toggle(this.hiddenClass, !searchQuery);
    this.clearResults();

    if (searchQuery) {
      this.getSearchResults(searchQuery);
    }
  }

  debounce = (callback, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => callback(...args), wait);
    };
  };

  clearResults() {
    this.collectionResults.innerHTML = '';
    this.pageResults.innerHTML = '';
    this.productResults.innerHTML = '';
  }

  async getSearchResults(searchQuery) {
    try {
      const response = await fetch(`/search/suggest.json?q=${searchQuery}&resources[limit]=${this.limit}&resources[limit_scope]=each`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      this.renderSearchResults(data.resources.results, searchQuery);
    } catch (error) {
      console.error('Error fetching search results:', error);
    }
  }

  async renderSearchResults(results, searchQuery) {
    this.clearResults();

    const {
      collections = [],
      pages = [],
      products = [],
    } = results;

    this.toggleResultsVisibility(products.length);

    this.renderLinks(collections, this.collectionResults, searchQuery);
    this.renderLinks(pages, this.pageResults, searchQuery);
    this.renderPopularCollections(collections);

    const productFetchPromises = Array.from(products).slice(0, this.limit).map(product => this.fetchProductCard(product.handle));
    const productCards = await Promise.all(productFetchPromises);
    productCards.forEach(productCard => {
      if (productCard) {
        productCard.classList.add('fade-in');
        this.productResults.appendChild(productCard);
      }
    });
  }

  toggleResultsVisibility(hasProducts) {
    this.productResults.classList.toggle(this.hiddenClass, !hasProducts);
    this.submitButton.classList.toggle(this.hiddenClass, !hasProducts);
    this.noResults.classList.toggle(this.hiddenClass, hasProducts);
  }

  renderLinks(items, container, searchQuery) {
    if (!Array.isArray(items)) return;

    if (items.length === 0) {
      const noResultsText = `No results for "${searchQuery}"`;
      container.innerHTML = `<p class="tw-text-sm">${noResultsText}</p>`;
      return;
    }


    const linkClass = 'tw-text-black tw-text-sm tw-no-underline hover:tw-underline tw-block tw-py-1';
    const fragment = document.createDocumentFragment();

    Array.from(items).slice(0, 4).forEach(item => {
      const link = document.createElement('a');
      link.setAttribute('role', 'link');
      link.setAttribute('tabindex', '0');
      link.setAttribute('title', item.title);
      link.setAttribute('aria-label', item.title);
      link.href = item.url;
      link.className = linkClass;
      link.textContent = item.title;
      fragment.appendChild(link);
    });

    container.appendChild(fragment);
  }

  renderPopularCollections(collections) {
    if (!Array.isArray(collections)) return;

    if (collections.length === 0) {
      this.popularCollections.classList.remove(this.hiddenClass);
    } else {
      this.popularCollections.classList.add(this.hiddenClass);
    }
    
  }

  async fetchProductCard(handle) {
    try {
      const response = await fetch(`/products/${handle}?view=wr-product-card`, {
        credentials: 'same-origin',
        method: 'GET',
      });
      const responseText = await response.text();
      return new DOMParser().parseFromString(responseText, 'text/html').querySelector('wr-product-card');
    } catch (error) {
      console.error('Error fetching product card:', error);
      return null;
    }
  }
}

customElements.get('wr-search') || customElements.define('wr-search', wrSearch);
